import * as React from 'react';

import type { VariantProps } from 'tailwind-variants';
import { tv } from 'tailwind-variants';

import { Typography } from '../../atoms/typography';

const colorChipVariants = tv({
  slots: {
    base: 'flex flex-row items-center gap-x-2 rounded-lg cursor-auto',
    counter:
      'flex justify-center items-center align-middle text-base-white shadow-counter rounded flex-shrink-0',
  },
  variants: {
    variant: {
      sm: {
        base: 'h-5 pl-2 py-[0.125rem] pr-[0.125rem]',
        counter: 'h-4 w-4 text-xs',
      },
      md: {
        base: 'h-7 pl-2 py-1 pr-1',
        counter: 'h-5 w-5 text-base',
      },
    },
  },
  defaultVariants: {
    variant: 'md',
  },
});

export type ColorChipProps = React.HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof colorChipVariants> & {
    text?: string;
    rightSideContent?: string | number;
    className?: string;
  };

export const ColorChip = React.forwardRef<HTMLDivElement, ColorChipProps>(
  ({ variant, className, ...props }, ref) => {
    const { base, counter } = colorChipVariants({
      variant,
      className,
    });

    return (
      <div
        className={base({
          className,
        })}
        ref={ref}
      >
        <Typography
          variant={variant === 'sm' ? 'body5' : 'body4'}
          className="text-base-white min-w-0 flex-1 truncate whitespace-nowrap"
        >
          {props.text}
        </Typography>
        <span className={counter()}>{props.rightSideContent}</span>
      </div>
    );
  },
);

ColorChip.displayName = 'ColorChip';
